export enum EBudgetGridOptions {
    CREATE = "CREATE",
    PREVIEW = "PREVIEW",
    EDIT = "EDIT",
    DOWNLOADPDF = "DOWNLOADPDF",
    SENDBYEMAIL = "SENDBYEMAIL",
    DUPLICATE = "DUPLICATE",
    CANCEL = "CANCEL",
    PREINVOICE = "PREINVOICE",
    ORDERS = "ORDERS"
}
export const EBudgetGridOptionsValues: { [key in EBudgetGridOptions]: number } = {
    [EBudgetGridOptions.CREATE]: 0,
    [EBudgetGridOptions.PREVIEW]: 1,
    [EBudgetGridOptions.EDIT]: 2,
    [EBudgetGridOptions.DOWNLOADPDF]: 3,
    [EBudgetGridOptions.SENDBYEMAIL]: 4,
    [EBudgetGridOptions.DUPLICATE]: 5,
    [EBudgetGridOptions.CANCEL]: 6,
    [EBudgetGridOptions.PREINVOICE]:7,
    [EBudgetGridOptions.ORDERS]: 8
};